module.exports = __webpack_public_path__ + "static/media/NoCompromiseGaming.png.png.e4c74bf8.webp";